import { useCallback, useEffect, useState } from "react"
import styles from "./store.module.css"
import StoreHeader from "./Store/StoreHeader"
import ProductManager from "./Store/ProductManager"
import ProductFilters from "./Store/ProductFilters"
import ProductGrid from "./Store/ProductGrid"
import { api } from "@/utils/apiService"
import { useAuth } from "@/components/context/AuthContext"
import { useTheme } from "@/components/context/ThemeContext"
import { toast } from "react-toastify"

export default function StoreSection() {
  const { user, token } = useAuth();
  const { theme } = useTheme();
  const [searchTerm, setSearchTerm] = useState("")
  const [showProductManager, setShowProductManager] = useState(false)
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(false);

  const handleAddProduct = async (newProduct) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("name", newProduct.name);
    formData.append("details", newProduct.details);
    formData.append("price", newProduct.price);
    formData.append("image", newProduct.image);  

    try {
      const res = await api.post("/admin/substore/add", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        }
      });

      const mssg = res.data.message || "Added new product successfully";
      toast.success(mssg);
      fetchProducts();
    } catch (error) {
      console.log("Error Adding Product ::", error);
      const mssg = error?.response?.data?.message || "Error adding product";
      toast.error(mssg);
    } finally {
      setShowProductManager(false)
    }
  }

  const handleRemoveProduct = async (productId) => {
    setLoading(true);
    try {
      const res = await api.delete(`/admin/substore/delete/${productId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });

      const mssg = res.data.message || "Removed product successfully";
      toast.success(mssg);
      fetchProducts();
    } catch (error) {
      console.log("Error Deleting Product ::", error);
      const mssg = error?.response?.data?.message || "Error removing product";
      toast.error(mssg);
    }
  }

  
  const handleUpdateProduct = async (updatedProduct) => {
    setLoading(true)
    const formData = new FormData();
    formData.append("name", updatedProduct.name);
    formData.append("details", updatedProduct.details);
    formData.append("price", updatedProduct.price);
    formData.append("image", updatedProduct.image); 
    
    try {
      const res = await api.put(`/admin/substore/update/${updatedProduct._id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        }
      });
      
      const mssg = res.data.message || "Updated product successfully";
      toast.success(mssg);
      fetchProducts()
    } catch (error) {
      console.log("Error Updating Product ::", error);
      const mssg = error?.response?.data?.message || "Error updating product";
      toast.error(mssg);
    }
  }

  const fetchProducts = useCallback(async () => {
    setLoading(true)
    try {
      let res;
      if(user && user?.role === "admin") {
        res = await api.get("/admin/substore/all", {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
      } else {
        res = await api.get("/substore/products");
      }

      setProducts(res.data)
    } catch (error) {
      console.log("Error Fetching Products ::", error);
      const errMssg = error?.response?.data?.message || "Error fetching products";
      toast.error(errMssg);
    } finally {
      setLoading(false);
    }
  }, []);
  
  useEffect(() => {
    fetchProducts();
  }, [fetchProducts])
  

  return (
    <div className={`${styles.storePage} ${theme === 'dark' ? 'dark' : ''}`}>
      <StoreHeader onAddProduct={() => setShowProductManager(true)} />
      {showProductManager && (
        <ProductManager onClose={() => setShowProductManager(false)} onAddProduct={handleAddProduct} />
      )}
      <div className={styles.storeContainer}>
        <ProductFilters
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
        <ProductGrid
          searchTerm={searchTerm}
          products={products}
          onRemoveProduct={handleRemoveProduct}
          onUpdateProduct = {handleUpdateProduct}
          isLoading={loading}
        />
      </div>
    </div>
  )
}
